import { render, staticRenderFns } from "./SelectReportTypeComponent.vue?vue&type=template&id=34d22cb3&"
import script from "./SelectReportTypeComponent.vue?vue&type=script&lang=js&"
export * from "./SelectReportTypeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports